import { MediaQueueSourceErrorType } from 'shared/src/api/types'
import { TFunction } from 'i18next'
import { addProps, addEffect, flowMax, SimpleUnchangedProps } from 'ad-hok'
import { addOptionalQueryParam } from 'shared/src/utils/addNavigate'

import { addTranslationHelpers } from './addTranslationHelpers'
import { addToastContext } from '../components/toastContext'

export type SocialService = 'instagram' | 'tikTok'

const KNOWN_ERRORS: Partial<Record<MediaQueueSourceErrorType, string>> = {
  loginCanceled: 'admin.resources.queue.errors.loginCanceled' as const,
  mismatchedScopes: 'admin.resources.queue.errors.mismatchedScopes',
  noPage: 'admin.resources.queue.errors.noPage',
  pageNotLinkedToInstagram:
    'admin.resources.queue.errors.pageNotLinkedToInstagram',
}

const translateError = (
  error: MediaQueueSourceErrorType,
  t: TFunction
): string =>
  t((KNOWN_ERRORS[error] as any) ?? 'admin.resources.queue.errors.unknown')

export const showSocialLinkingErrors: SimpleUnchangedProps = flowMax(
  addOptionalQueryParam('error'),
  addProps(({ error }) => ({
    error: error as MediaQueueSourceErrorType,
  })),
  addTranslationHelpers,
  addProps(({ error, t }) => ({
    error: error ? translateError(error, t) : null,
  })),
  addToastContext,
  addEffect(
    ({ error, showErrorToast, t }) =>
      () => {
        if (error) {
          showErrorToast({
            title: t('admin.mediaQueue.linkingError'),
            details: error,
          })
        }
      },
    ['error']
  )
)
